<template>
    <label v-if="label" class="form-label">{{label}}</label><br v-if="label">
    <div class="btn-group w-100" :class="{'is-invalid':hasError(),disabled:disabled}" role="group">
        <template v-for="(option, value) in options">
            <input type="radio" class="btn-check" :disabled="disabled" :name="name" :id="`form_${name}_${value}`" :value="value" v-model="model" @change="emitValue($event)">
            <label class="btn" :class="classPrefix+option.class" :for="`form_${name}_${value}`">{{option.label}}</label>
        </template>
    </div>
    <div v-html="feedbackHtml()"></div>
</template>
<script>
import SimpleFormElementMixin from "./SimpleFormElementMixin";

export default {
    emits: ['update:modelValue', 'update'],
    props : {
        options : {type: Object, required: true},
        classPrefix : {type: String, required: false, default: 'btn-outline-'},
    },
    computed: {
        model: {
            get() {
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            }
        }
    },
    methods: {
        emitValue($event){
            this.$emit('update:modelValue', $event.target.value);
            this.$emit('update');
        }
    },
    mixins: [SimpleFormElementMixin]
}
</script>
